import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.extend(customParseFormat)

export interface DateDayFilter {
  kind: 'date-day'
  from: string
  to: string
}

/**
 * Conserva el día del calendario local, sin convertirlo a UTC.
 * @author isi-template
 * */
export const toDateDayFilter = (value: unknown): DateDayFilter | undefined => {
  const date =
    typeof value === 'string'
      ? dayjs(
          value.trim(),
          ['YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm'],
          true,
        )
      : dayjs.isDayjs(value)
        ? value
        : value instanceof Date
          ? dayjs(value)
          : undefined

  if (!date?.isValid()) return undefined

  const day = date.format('YYYY-MM-DD')
  return { kind: 'date-day', from: `${day} 00:00:00`, to: `${day} 23:59:59` }
}

/**
 * Verifica si un filtro de fecha pertenece al formato kind, from, to => DateDayFilter
 * @author isi-template
 * @param value
 */
export const isDateDayFilter = (value: unknown): value is DateDayFilter =>
  typeof value === 'object' &&
  value !== null &&
  'kind' in value &&
  value.kind === 'date-day' &&
  'from' in value &&
  typeof value.from === 'string' &&
  'to' in value &&
  typeof value.to === 'string'
